(() => {
	function init() {
		// Scroll trigger
		// ----------------------------------------

		const triggers = document.querySelectorAll('[data-scroll-to]');

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				scrollTo(trigger.dataset.scrollTo);
			});
		});

		// Hash trigger
		// ----------------------------------------

		if (window.location.hash) {
			const el = document.querySelector(window.location.hash);

			if (el) {
				scrollTo(el);
			}
		}
	}

	function scrollTo(selector) {
		gsap.to(window, {
			duration: 0.5,
			scrollTo: selector
		});
	}

	// Events
	// ----------------------------------------

	$WINDOW.on('load', () => {
		init();
	});

	$WINDOW.on('page:load-completed', (e) => {
		init();
	});
})();
